import { render } from "./PersonalSummarySection.vue?vue&type=template&id=24466432&lang=true"
import script from "./PersonalSummarySection.vue?vue&type=script&lang=js"
export * from "./PersonalSummarySection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__